import { render, staticRenderFns } from "./CustomEmailServiceListLine.vue?vue&type=template&id=84b5112a"
import script from "./CustomEmailServiceListLine.vue?vue&type=script&lang=js"
export * from "./CustomEmailServiceListLine.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports